import * as React from 'react'
import {
  PressableProps,
  Pressable,
  View,
  ViewStyle,
  StyleProp,
  StyleSheet,
} from 'react-native'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'

export type Props = PressableProps & {
  buttonStyles?: StyleProp<ViewStyle>
  children?: React.ReactNode
}

export function BaseCircleButton({
  disabled = false,
  buttonStyles = styles.button,
  children,
  ...rest
}: Props) {
  return (
    <Pressable disabled={disabled} {...rest}>
      <View style={[buttonStyles, disabled && { opacity: 0 }]}>{children}</View>
    </Pressable>
  )
}

export const styles = StyleSheet.create({
  button: {
    flexGrow: 0,
    height: 50,
    width: 50,
    borderRadius: 25,
    borderColor: Colors.white,
    backgroundColor: Colors.white,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    shadowColor: Colors.originalBlack,
    marginHorizontal: 4,
    marginVertical: 12,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  buttonLarge: {
    width: 60,
    height: 60,
    borderRadius: 30,
  },
  buttonAltPrimary: { backgroundColor: Colors.primary },
  buttonAltGray: {
    backgroundColor: Colors.neutralGray,
  },
  buttonText: {
    fontFamily: Fonts.type.bold,
    fontWeight: 'bold',
    color: Colors.white,
    fontSize: 14,
    lineHeight: 14,
  },
})
